import type { Lang } from "@noli/core";

export enum Order_Words {
  "MyOrder" = "MyOrder",
  "Questions" = "Questions",
  "ContactCustomer" = "ContactCustomer",
  "ScanCode" = "ScanCode",
  "PleaseNote" = "PleaseNote",
  "OrderPaid" = "OrderPaid",
  "Completed" = "Completed",
  "BoughtAnything" = "BoughtAnything",
  "GetAcceleration" = "GetAcceleration",
  "OriginalPrice" = "OriginalPrice",
  "End-of-the-Page" = "End-of-the-Page",
}

export const orderLangRecords: Record<Lang, Record<Order_Words, string>> = {
  zh: {
    [Order_Words["MyOrder"]]: "我的订单",
    [Order_Words["Questions"]]: "开发票、对订单有疑问？",
    [Order_Words["ContactCustomer"]]: "联系客服",
    [Order_Words["ScanCode"]]: "请扫码联系客服",
    [Order_Words["PleaseNote"]]: "添加时请备注“售后”",
    [Order_Words["OrderPaid"]]: "订单已支付",
    [Order_Words["Completed"]]: "已完成",
    [Order_Words["BoughtAnything"]]: "您还没有购买过任何内容",
    [Order_Words["GetAcceleration"]]: "可点击「获得加速」按钮进行算力加速~",
    [Order_Words["OriginalPrice"]]: "原价",
    [Order_Words["End-of-the-Page"]]: "已经到底啦~",
  },
  en: {
    [Order_Words["MyOrder"]]: "My Order",
    [Order_Words["Questions"]]: "Invoicing, questions about orders？",
    [Order_Words["ContactCustomer"]]: "Contact customer service",
    [Order_Words["ScanCode"]]: "Scan the code to contact customer service",
    [Order_Words["PleaseNote"]]: 'Please note "After sales" when adding',
    [Order_Words["OrderPaid"]]: "Order paid",
    [Order_Words["Completed"]]: "Completed",
    [Order_Words["BoughtAnything"]]: "You haven't bought anything yet",
    [Order_Words["GetAcceleration"]]:
      'Click the "Get Acceleration" button to accelerate the calculation force~',
    [Order_Words["OriginalPrice"]]: "Original Price",
    [Order_Words["End-of-the-Page"]]: "End of the Page ~",
  },
};
